/**
 * Sinaliza que um unload/reload está sendo disparado pela PRÓPRIA aplicação
 * (ex.: o EventPixelNavigationGuard recarregando a página para resetar o pixel
 * de evento), e não por uma tentativa do usuário de sair da página.
 *
 * Handlers de `beforeunload` que exibem o prompt nativo ("os dados serão
 * perdidos") devem consultar `isAppControlledReload()` e abortar quando o
 * recarregamento é controlado pela aplicação — caso contrário o navegador
 * mostra o diálogo "Leave site?" indevidamente para uma navegação interna.
 */
let appControlledReload = false;

export const markAppControlledReload = (): void => {
	appControlledReload = true;

	// Rede de segurança: se o unload não acontecer (ex.: navegação abortada), o
	// flag não pode ficar preso e suprimir um `beforeunload` legítimo mais
	// tarde. O reset roda no próximo macrotask — depois que o `beforeunload`
	// (síncrono ao unload programático) já foi processado.
	setTimeout(() => {
		appControlledReload = false;
	}, 0);
};

export const isAppControlledReload = (): boolean => appControlledReload;

/** Reset determinístico — uso exclusivo em testes. */
export const __resetAppControlledReload = (): void => {
	appControlledReload = false;
};
